export default __webpack_public_path__ + "static/media/deleteIcon.86e6769c.svg";